import React from 'react'
import ContactoBanner from '../../shared/contactBanner/contacto-banner'
import Descripciones from '../../shared/descriptions/Descripciones'
import constantes from '../../constantes/constantes'
import Banner from '../../shared/banners/banner'
import fondoBanner from '../../../assets/images/desarrolloSoftware/bannerDesarrollo.svg'
import Proceso from './proceso'

const servicios = constantes.listaComponentes
const descripcionProceso = constantes.descripcionProceso

const Desarrollo = (): any => {
  return (
    <div className="relative w-full h-full flex flex-col justify-center items-center">
      <div className='sticky top-0 z-10'>
      <Banner
        image={fondoBanner}
        title="Desarrollo de Software"
        subtitle=""
        saltolinea={true}
        description="Diseñamos sistemas sólidos, escalables y fáciles de mantener"
        desarrollo
      />
      </div>
      <div className='sticky bg-white top-0 z-10 w-screen text-center '>
      <div className="inline-flex flex-col justify-start items-start gap-[60px] mb:[45px] md:mb-[162px] mt-[55px] md:mt-[100px] px-[6px]">
        <Descripciones
          items={descripcionProceso}
          titulo="Proceso"
          subrayado="Proceso"
          blanco={false}
          className="text-[64px]"
        />
        <Proceso />
      </div>
      <div className="mb-32">
        <Descripciones
          items={servicios}
          titulo="Componentes"
          subrayado="Componentes"
          blanco={false}
          iconosComponentes={true}
        />
      </div>
      <ContactoBanner />
      </div>
    </div>
  )
}

export default Desarrollo
